import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        isVisible: true,
        isOpen: false,
    },
    mutations: {
        setNavigationDrawerIsVisible(state, navigationDrawerIsVisible) {
            Vue.set(state, 'isVisible', navigationDrawerIsVisible);
        },
        setNavigationDrawerIsOpen(state, navigationDrawerIsOpen) {
            Vue.set(state, 'isOpen', navigationDrawerIsOpen);
        },
    },
    actions: {
        setNavigationDrawerIsVisible({ commit }, isVisible) {
            commit('setNavigationDrawerIsVisible', isVisible);
        },
        setNavigationDrawerIsOpen({ commit }, isOpen) {
            commit('setNavigationDrawerIsOpen', isOpen);
        },
    },
    getters: {
        isNavigationDrawerVisible: (state) => state.isVisible,
        isNavigationDrawerOpen: (state) => state.isOpen,
    },
}
